import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import PermissionGrid from './PermissionGrid';

const GroupForm = ({ group, onSave, onCancel }) => {
  const [name, setName] = useState(group?.name || '');
  const [description, setDescription] = useState(group?.description || '');
  const [permissions, setPermissions] = useState(group?.permissions || []);
  const [allPermissions, setAllPermissions] = useState([]);

  useEffect(() => {
    api.get('/groups/permissions/all').then(res => setAllPermissions(res.data));
  }, []);

  const togglePermission = (perm, newPermissions = null) => {
    if (newPermissions !== null) {
      setPermissions(newPermissions);
    } else {
      setPermissions(permissions.includes(perm)
        ? permissions.filter(p => p !== perm)
        : [...permissions, perm]);
    }
  };

  const toggleAll = () => {
    if (permissions.length === allPermissions.length) setPermissions([]);
    else setPermissions(allPermissions);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({ name, description, permissions });
  };

  return (
    <form onSubmit={handleSubmit} className="p-6 bg-white rounded-lg shadow-xl max-w-4xl mx-auto max-h-[90vh] overflow-y-auto">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">
          {group?._id ? 'Edit Group' : 'Create New Group'}
        </h2>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        <div>
          <label className="block mb-2 text-sm font-medium text-gray-700">Group Name</label>
          <input
            value={name}
            onChange={e => setName(e.target.value)}
            placeholder="Enter group name"
            required
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>
        <div>
          <label className="block mb-2 text-sm font-medium text-gray-700">Description</label>
          <input
            value={description}
            onChange={e => setDescription(e.target.value)}
            placeholder="Enter group description"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>
      </div>
      
      <div className="mb-6">
        <label className="block mb-4 text-lg font-medium text-gray-900">Permissions</label>
        <PermissionGrid
          allPermissions={allPermissions}
          selectedPermissions={permissions}
          onToggle={togglePermission}
          onToggleAll={toggleAll}
        />
      </div>
      
      <div className="flex justify-end space-x-3 pt-4 border-t">
        <button 
          type="button" 
          onClick={onCancel}
          className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          Cancel
        </button>
        <button 
          type="submit"
          className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          {group?._id ? 'Update Group' : 'Create Group'}
        </button>
      </div>
    </form>
  );
};

export default GroupForm; 